// QR rendering as a service: the TOTP enrollment screen draws the otpauth:// URI client-side (the
// secret never rides an <img src> to any third party). Behind an interface so MfaStore tests
// inject a fake instead of pulling the qrcode encoder into the test run.

import QRCode from 'qrcode';
import { token } from '@/infrastructure/container';

export interface IQr {
  /** The text as a QR code, rendered to a `data:image/svg+xml` URL for a plain <img>. */
  toSvgDataUrl(text: string): Promise<string>;
}

export const TOKEN_IQr = token<IQr>('IQr');

export class Qr implements IQr {
  async toSvgDataUrl(text: string): Promise<string> {
    const svg = await QRCode.toString(text, { type: 'svg', margin: 1 });
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  }
}

/** Test fake: a recognizable sentinel URL embedding the encoded text. */
export class FakeQr implements IQr {
  async toSvgDataUrl(text: string): Promise<string> {
    return `data:image/svg+xml;utf8,FAKE-QR(${text})`;
  }
}
